export default __webpack_public_path__ + "static/media/jeroen-offerjins.6b58592c.jpeg";